import { render, staticRenderFns } from "./MappingProposal.vue?vue&type=template&id=0ee8e2ef&lang=pug&"
import script from "./MappingProposal.vue?vue&type=script&lang=ts&"
export * from "./MappingProposal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports